<template>
  <div>
    <TopoComponent></TopoComponent>

    <div>
      <h2>
        Confira nossos Termos de Uso e Políticas de Privacidade
      </h2>
    </div>
    <div class="termos-body">
      Nós, da <b>CONEXA SAÚDE</b>, consideramos que a relação com nossos
      <b>Usuários</b> deve ser pautada na maior confiança e respeito, para
      garantir a todos a melhor experiência possível.<br /><br />
      Entendemos que a leitura completa pode levar algum tempo. <br /><br />
      Então, caso não tenha disponibilidade neste momento, apresentamos abaixo
      um pequeno resumo dos pontos mais importantes.<br /><br />Para a
      compreensão completa e leitura total dos termos e condições gerais de uso
      da <b>Plataforma Conexa Saúde</b>, leia nossos
      <a
        style="text-decoration:underline!important"
        :href="linkTerms"
        target="_blank"
        >termos e condições gerais de uso</a
      >.
    </div>
    <div class="termos-footer form-signin">
      <button
        type="button"
        @click="() => this.$router.push('/verificar-cpf')"
        class="btn btn-delete"
        data-dismiss="modal"
      >
        Não aceito
      </button>
      <button
        type="button"
        @click="aceiteTermos"
        class="btn btn-primary button success"
      >
        Li e aceito o termo de uso
      </button>
    </div>
  </div>
</template>

<script>
import TopoComponent from "@/components/TopoComponent";
import firebase from 'firebase';

export default {
  name: "AceiteDosTermos",
  components: { TopoComponent },
  data: () => ({
    userToken: sessionStorage.getItem("token"),
    idClinica: sessionStorage.getItem("idclinica"),
    idPaciente: sessionStorage.getItem("idPaciente"),
    nomeClinica: sessionStorage.getItem("nomeClinica"),
    linkTerms: "",
  }),
  mounted() {
    const link = sessionStorage.getItem("urlTermo");
    if (!link || link.length === 0) {
      this.linkTerms = process.env.VUE_APP_TERMO_DEFAULT;
    } else {
      this.linkTerms = link;
    }
  },
  methods: {
    ativarDependente(token) {
      return this.$conexaApi
        .post("/integration/ativacao/paciente/" + token + "/ativar-dependente")
        .catch((error) => {
          this.$notify({
            duration: 4000,
            group: "mensagens",
            type: "error",
            title: "Mensagem",
            text: error.response.data.msg,
          });
        });
    },
    async ativarTodosOsDependentes() {
      const dependentesParaAtivar =
        JSON.parse(sessionStorage.getItem("dependentesParaAtivar")) || [];
      if (dependentesParaAtivar.length) {
        for (const dependente of dependentesParaAtivar) {
          if(dependente) await this.ativarDependente(dependente.token);
        }
      }
    },
    async aceiteTermos() {
      await this.ativarTodosOsDependentes();
      this.enviarEventoAceitoTermo();
      return this.$conexaApi
        .post(
          `/integration/ativacao/paciente/${this.userToken}/aceitar-termo`,
          {
            idClinica: this.idClinica,
          }
        )
        .then(() => {
          let clinicas = JSON.parse(sessionStorage.getItem("clinicas"));
          clinicas = clinicas.filter((clinica) => {
            return parseInt(clinica.idPaciente) !== parseInt(this.idPaciente);
          });
          if (clinicas.length) {
            this.$notify({
              duration: 4000,
              group: "mensagens",
              type: "success",
              text: `Conta ${
                this.nomeClinica
              } ativada. Para concluir, é necessário ativar todas as suas contas`,
            });
            this.$router.push("/selecionar-clinica");
          } else {
            sessionStorage.removeItem("cpf");
            sessionStorage.removeItem("dependentes");
            sessionStorage.removeItem("clinicas");
            sessionStorage.removeItem("totaldependentes");
            sessionStorage.removeItem("dependentesParaAtivar");
            this.$router.push("/sucesso");
          }
        })
        .catch((error) => {
          this.$notify({
            duration: 4000,
            group: "mensagens",
            type: "error",
            title: "Atenção",
            text:
              (error.response &&
                error.response.data &&
                error.response.data.msg) ||
              "Tivemos um problema",
          });
        });
    },
    enviarEventoAceitoTermo() {
      firebase.analytics().logEvent('TMN_Aceite_Termo_Ativacao_Conta', {'Ação': 'Clique no aceite do termo (verifique sua conta)', 'Rotulo':'Clique no aceite do termo', 'Categoria': 'N/A', 'Tela':'aceite termo'});
    },
  },
};
</script>
